import { Appointment } from '@weave/schema-gen-ts/dist/schemas/schedule/calendar-events/v1/calendar_events.pb';
import { SchedulerV3 } from '@frontend/api-schedule-v3';
import { useCalendarEventsFormTypeShallowStore } from '@frontend/schedule-helpers';
import { CalendarEventsEnums } from '../../types';
import { NewAppointmentFormContainer } from './NewAppointmentFormContainer';
import { NewAppointmentFormContainerV3 } from './NewAppointmentFormContainerV3';
import { OutOfOfficeEventFormContainer } from './OutofOfficeEventFormContainer';
import { OutOfOfficeEventFormContainerV3 } from './OutofOfficeEventFormContainerV3';

type CalendarEventsModalContentProps = {
  closeModal: () => void;
  onAppointmentSuccess?: (appointment?: Appointment) => void;
};

export const CalendarEventsModalContent = ({ closeModal, onAppointmentSuccess }: CalendarEventsModalContentProps) => {
  const { isScheduleV3FlagEnabled } = SchedulerV3.Helpers.useGetSchedulerV3FeatureFlagDetails();

  const { selectedForm, setSelectedForm, setSelectedPerson } = useCalendarEventsFormTypeShallowStore(
    'selectedForm',
    'setSelectedForm',
    'setSelectedPerson'
  );
  const isNewAppointmentEvent = selectedForm === CalendarEventsEnums.APPOINTMENT_EVENT;

  const handleCloseModal = () => {
    setSelectedForm('');
    setSelectedPerson(null);
    closeModal();
  };

  return (
    <>
      {isNewAppointmentEvent &&
        (isScheduleV3FlagEnabled ? (
          <NewAppointmentFormContainerV3
            eventType={selectedForm}
            closeModal={handleCloseModal}
            onAppointmentSuccess={onAppointmentSuccess}
          />
        ) : (
          <NewAppointmentFormContainer
            eventType={selectedForm}
            closeModal={handleCloseModal}
            onAppointmentSuccess={onAppointmentSuccess}
          />
        ))}
      {!isNewAppointmentEvent &&
        selectedForm &&
        (isScheduleV3FlagEnabled ? (
          <OutOfOfficeEventFormContainerV3 closeModal={handleCloseModal} eventType={selectedForm} />
        ) : (
          <OutOfOfficeEventFormContainer closeModal={handleCloseModal} eventType={selectedForm} />
        ))}
    </>
  );
};
